import React, { useState, useEffect } from 'react';
import { Col, Row, Table, Spin } from "antd";
import { useSelector } from "react-redux";

import { getDeliveriesList } from '../../redux/dashboard/dashboardActions';
import { formatCurrency, formatDate, parseDate } from '../../utils/utils';

const DeliveriesTable = () => {
  const [spinStatus, setSpinStatus] = useState(false);

  const { deliveriesList } = useSelector((state) => state.dashboard);

  useEffect(async () => {
    setSpinStatus(true);
    await getDeliveriesList({ cardCode: localStorage.getItem('cardCode') });
    setSpinStatus(false);
  }, []);

  const columns = [
    {
      title: "Delivery No",
      dataIndex: "delNum",
      key: "delNum",
      width: 90,
      fixed: 'left',
      sorter: (a, b) => a.delNum - b.delNum,
      filterSearch: true,
      filters: [...new Set(deliveriesList?.map(item => item.delNum))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.delNum === value,
    },
    {
      title: "Ref No",
      dataIndex: "refNo",
      key: "refNo",
      width: 90,
      sorter: (a, b) => a.refNo - b.refNo,
      filterSearch: true,
      filters: [...new Set(deliveriesList?.map(item => item.refNo))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.refNo === value,
    },
    {
      title: "Ship Method",
      dataIndex: "shipMethod",
      key: "shipMethod",
      width: 100,
      sorter: (a, b) => (a.shipMethod || '').localeCompare(b.shipMethod || ''),
      filterSearch: true,
      filters: [...new Set(deliveriesList?.map(item => item.shipMethod))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.shipMethod === value,
    },
    {
      title: "Delivery Ref",
      dataIndex: "delref",
      key: "delref",
      width: 100,
      sorter: (a, b) => (a.delref || '').localeCompare(b.delref || ''),
      filterSearch: true,
      filters: [...new Set(deliveriesList?.map(item => item.delref))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.delref === value,
    },
    {
      title: "Posting Date",
      dataIndex: "postingDate",
      key: "postingDate",
      width: 90,
      render: (text, record) => <div className={'hp-text-center'}>{formatDate(record.postingDate)}</div>,
      sorter: (a, b) => {
        const dateA = parseDate(a.postingDate);
        const dateB = parseDate(b.postingDate);
        if (!dateA && !dateB) return 0;
        if (!dateA) return -1;
        if (!dateB) return 1;
        return dateA.valueOf() - dateB.valueOf();
      },
      filterSearch: true,
      filters: [...new Set(deliveriesList?.map(item => item.postingDate))].map(val => ({ text: formatDate(val), value: val })),
      onFilter: (value, record) => record.postingDate === value,
    },
    {
      title: "Delivery Date",
      dataIndex: "delDate",
      key: "delDate",
      render: (text, record) => <div className={'hp-text-center'}>{formatDate(record.delDate)}</div>,
      sorter: (a, b) => {
        const dateA = parseDate(a.delDate);
        const dateB = parseDate(b.delDate);
        if (!dateA && !dateB) return 0;
        if (!dateA) return -1;
        if (!dateB) return 1;
        return dateA.valueOf() - dateB.valueOf();
      },
      width: 90,
      filterSearch: true,
      filters: [...new Set(deliveriesList?.map(item => item.delDate))].map(val => ({ text: formatDate(val), value: val })),
      onFilter: (value, record) => record.delDate === value,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      width: 80,
      render: (text, record) => <div className={'hp-text-center'}>{text}</div>,
      sorter: (a, b) => a.quantity - b.quantity,
      filterSearch: true,
      filters: [...new Set(deliveriesList?.map(item => item.quantity))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.quantity === value,
    },
    {
      title: "Freight",
      dataIndex: "freight",
      key: "freight",
      width: 80,
      render: (text, record) => <div className={'hp-text-right'}>{formatCurrency(text)}</div>,
      sorter: (a, b) => a.freight - b.freight,
      filterSearch: true,
      filters: [...new Set(deliveriesList?.map(item => item.freight))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.freight === value,
    },
  ];

  return (
    <Spin spinning={spinStatus} size="large">
      <Row gutter={[18, 18]}>
        <Col span={24}>
          <Table
            dataSource={deliveriesList}
            size="small"
            bordered
            columns={columns}
            pagination={{
              position: ['bottomCenter'],
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ['10', '25', '50', '100'],
            }}
            scroll={{ x: '1000px' }}
          />
        </Col>
      </Row>
    </Spin>
  );
};

export default DeliveriesTable;